export const ROUTER_PATH = {
  HOME: "routes.home",
  CART: "routes.cart",
  SIGN_IN: "routes.sign_in",
  SIGN_UP: "routes.sign_up",
  SIGN_OUT: "routes.sign_out",
  CONFIRM_OTP: "routes.confirm_otp",
  FORGOT_PASSWORD: "routes.forgot_password",
  PROFILE: "routes.profile_information",
  PROFILE_DETAIL: "routes.profile_information_detail",
  ORDERS: "routes.orders",
  ORDER_DETAIL: "routes.order_detail",
  PAYMENT_RETURN: "routes.payment_return",
  PRODUCTS_WISH: "routes.products_wish",
  LUCKY_WHEEL: "routes.event_lucky_wheel",
  LUCKY_WHEEL_SUMMARY: "routes.event_lucky_wheel_summary",
  EVENT_VOUCHER_LUCKY: "routes.event_voucher_lucky",
  PRODUCT: "routes.product",
  PRODUCT_DETAIL_DEFAULT: "routes.product_detail_default",
  SUB_ROUTES_PRODUCT_DETAIL: "sub_routes.products_detail",
  MEMBERSHIP: "routes.membership",
  POINT_HISTORIES: "routes.point_histories",
  CHANGE_PASSWORD: "routes.change_password",
  WARRANTY: "routes.warranty",
  STORE_AGENCY: "routes.store_agency",
  EVENT: "routes.event",
  TOPIC: "routes.topic",
  TOPIC_DETAIL: "routes.topic_detail",
  POLICY_AND_GENERAL_TERMS: "routes.policy_and_general_terms",
  POLICY_AND_GENERAL_TERM_DETAIL: "routes.policy_and_general_term_detail",
  HELP: "routes.help",
  SEARCH: "routes.search",
  SEARCH_CAT: "routes.search_cat",
  PRODUCT_DETAIL: "routes.product_detail",
  CATEGORY: "routes.category",
  SPECIAL_MATTRESS: "routes.special_mattress",
  PRODUCTS_CATEGORY: "routes.products_category",
  CATEGORY_MATTRESS: "routes.category_nem",
  CATEGORY_PILLOW: "routes.category_goi",
  CATEGORY_DRAP: "routes.category_drap",
  CATEGORY_BED: "routes.category_giuong",
  CATEGORY_SOFA: "routes.category_sofa",
  CHECKOUT: "routes.checkout",
};

export const DEVICE_MOBILE = "MOBILE";
export const DEVICE_TABLET = "TABLET";
export const DEVICE_DESKTOP = "DESKTOP";

export const VERIFY_OTP_ERROR_CODES: any = {
  VERIFY_OTP_INVALID: "VERIFY_OTP_INVALID",
  VERIFY_OTP_PHONE_NUMBER_INVALID: "VERIFY_OTP_PHONE_NUMBER_INVALID",
  VERIFY_OTP_NOT_EXPIRED: "VERIFY_OTP_NOT_EXPIRED",
  VERIFY_OTP_RATE_LIMITED: "VERIFY_OTP_RATE_LIMITED",
  VERIFY_OTP_EXPIRED: "VERIFY_OTP_EXPIRED",
  VERIFY_OTP_WRONG_OTP_MORE_THAN_5: "VERIFY_OTP_WRONG_OTP_MORE_THAN_5",
  MODEL_INVALID: "MODEL_INVALID",
};

export const OTP_ERROR_CODES_PREVENT_CREATE_OERDER = [
  VERIFY_OTP_ERROR_CODES.VERIFY_OTP_WRONG_OTP_MORE_THAN_5,
  VERIFY_OTP_ERROR_CODES.VERIFY_OTP_RATE_LIMITED,
];

export const OTP_ERROR_MESSAGES: any = {
  VERIFY_OTP_INVALID: "Mã xác nhận chưa chính xác",
  VERIFY_OTP_EXPIRED: "Mã xác nhận đã hết hạn",
};

export const LIMIT_SECTIONS = 20;
export const SECTION_BANNER = ["606282944c8a4d6dfab0334f"];
export const SECTION_CATEGORY_INFORMATION = [
  "612ef5f74bc4bc1df1949321",
  "612f1c014bc4bc1df194968a",
  "61317ee36b5f9b603e84123d",
];
export const SECTION_CATEGORY_INFORMATION_V2 = [
  "613182346b5f9b603e841243",
  "613182b66b5f9b603e841246",
  "6131831d6b5f9b603e841249",
];
export const SECTION_CATEGORY_INFORMATION_V3 = ["613183986b5f9b603e84124b"];
export const SECTION_CATEGORY_INFORMATION_PAIR = ["6131fa3b6b5f9b603e841281"];
export const SECTION_TOPIC = ["6131ecd16b5f9b603e84126e"];
export const SECTION_EVENT_IMAGES = [
  "68ab2f7308b1902c90927e07",
  "6a2686ca2d0778ae3af066c6",
];

export const HOME_PRODUCT_SECTION_IDS = [
  "606282944c8a4d6dfab0334f",
  "6062d1aa8ac7317e3e5ba8d8",
  ...SECTION_CATEGORY_INFORMATION,
  "6131fa3b6b5f9b603e841281",
  "6131ecd16b5f9b603e84126e",
  ...SECTION_CATEGORY_INFORMATION_V2,
  ...SECTION_CATEGORY_INFORMATION_V3,
  "6073f523cd410f5bd7ea23af",
  ...SECTION_EVENT_IMAGES,
];
export const SECTION_CATEGORY_TOPIC = [
  "60694948e59bc61913bd8c86",
  "606bdd18cf98538280e37c17",
  "606d2d6bdbebc43cc4e747b4",
  "606c2a9c9fe2e896bd62745a",
  "606d2d26dbebc43cc4e747b2",
  "606d2ce6dbebc43cc4e747b0",
];
export const SECTION_CATEGORY_DESCRIPTION = [
  "6062d1aa8ac7317e3e5ba8d8",
  "606fb15a58be6ca7dab287e7",
  "6077c165dab9b92c758fbefc",
  "606fbb4b58be6ca7dab2908a",
  "60ab6c05d822a269866d8d05",
  "60ac6724b0d69462ae339da9",
];
export const SECTION_INFO_DESCRIPTION = ["60668fd2e9e2acd45db099ce"];
export const SECTION_PRODUCT = [
  "60628894342f8c5f1df79c31",
  "606c1030ae0e636d37ba7336",
  "606d236e8aaf68ff1cb7de16",
  "6076a483cd7c2a635b4f6a65",
  "606fc3c3e73d2ac062f0624e",
  "60769aa6cd7c2a635b4f6a3a",
  "60769dafcd7c2a635b4f6a3b",
  "6077c60835895fb6b22bd0d4",
  "6077c62c35895fb6b22bd0d5",
  "6077c64e35895fb6b22bd0d6",
  "6073e801b45e0662137ec86f",
  "60750d5e6063226a38e5836e",
  "60acbc27a7a9f71d58b54e55",
  "60acbc61a7a9f71d58b54e56",
  "60acc9e0a7a9f71d58b54e61",
  "60adafea6c0eb689f332010c",
  "60adb0bb6c0eb689f3320113",
  "60adb2126c0eb689f332011f",
  "60adb5776c0eb689f3320124",
];
export const SECTION_PRODUCT_DESCRIPTION = [
  "606c0521ae0e636d37ba7327",
  "606d24688aaf68ff1cb7de1d",
  "606d641b8aaf68ff1cb7de41",
  "6073b910b45e0662137ec867",
  "606fb827e73d2ac062f06239",
  "6073b93fb45e0662137ec869",
];
export const SECTION_STORE = ["6073f523cd410f5bd7ea23af"];

export const CATEGORY_IDS_SORT_BY_PRICE = [
  "5d2c53d0e25bfa5d1914a054",
  "60bf779a251a084a29851ae1",
  "60bf7852251a084a29851ae2",
  "60bf7a94251a084a29851ae3",
];

export const SECTION_SPECIAL_MATTRESS = [
  "614afd11cdc03a7d4055558f",
  // "614d4bb4f036b97668e257b0",
  "614d69f4972d010a127540b7",
];

export const SECTION_SPECIAL_MATTRESS_GIFS = "614d69f4972d010a127540b7";
export const SECTION_SPECIAL_MATTRESS_CATEGORIES = "614d4bb4f036b97668e257b0";
export const SECTION_SPECIAL_MATTRESS_ITEMS = "614afd11cdc03a7d4055558f";

export const SECTION_POPUP = "61801ea517ca086d72b5c9af";
export const SECTION_GRAND_OPENING = "6180a52517ca086d72b5cace";

export const KYMDAN_SPECIAL_DELUXE_PILLOW_PREFIX =
  "kymdan-special-deluxe-pillow-top";

export const WARRANTY_STEP = {
  REGISTER: "REGISTER",
  CONFIRM: "CONFIRM",
  RESULT: "RESULT",
};

export const PRODUCT_SORT = [
  { value: { position: 1 }, label: "sort_price_default", index: 0 },
  { value: { promotion_price: 1 }, label: "sort_price_ascending", index: 1 },
  { value: { promotion_price: -1 }, label: "sort_price_descending", index: 2 },
];
export const CHECKOUT_STEP = {
  SHIPPING_INFO: "params.routes.checkout.shipping.info",
  PAYMENT_METHOD: "params.routes.checkout.payment.method",
};

export const PROP_SOFA_ROSSY_LUXE_PREMIUM = "P";
export const PROP_SOFA_ROSSY_LUXE_SIMILI = "V";

export const PRODUCT_SOFA_ROSSY_LUXE_PROPS = {
  [PROP_SOFA_ROSSY_LUXE_SIMILI]: "Bọc Vinyl (Simili)",
  [PROP_SOFA_ROSSY_LUXE_PREMIUM]: "Bọc vải Premium",
};

export const PRODUCT_PROPS_SOFA_ROSSY_LUXE_COVER = [
  {
    value: PROP_SOFA_ROSSY_LUXE_PREMIUM,
    label: PRODUCT_SOFA_ROSSY_LUXE_PROPS[PROP_SOFA_ROSSY_LUXE_PREMIUM],
  },
  {
    value: PROP_SOFA_ROSSY_LUXE_SIMILI,
    label: PRODUCT_SOFA_ROSSY_LUXE_PROPS[PROP_SOFA_ROSSY_LUXE_SIMILI],
  },
];

export const PROP_BED_PREMIUM = "V";
export const PROP_BED_SIMILI = "S";

export const PRODUCT_SALON_PROPS: any = {
  [PROP_BED_SIMILI]: "Bọc Vinyl (Simili)",
  [PROP_BED_PREMIUM]: "Bọc vải Premium",
};

export const PRODUCT_PROPS_COVER = [
  {
    value: PROP_BED_PREMIUM,
    label: PRODUCT_SALON_PROPS[PROP_BED_PREMIUM],
  },
  {
    value: PROP_BED_SIMILI,
    label: PRODUCT_SALON_PROPS[PROP_BED_SIMILI],
  },
];

export const ID_CATEGORY_MATTRESS = "5be3b47a31495c2d429b0cc9";
export const ID_CATEGORY_SOFA = "5be3b47b31495c2d429b0dbb";
export const ID_CATEGORY_BED = "5be3b47a31495c2d429b0d1f";
export const ID_CATEGORY_PILLOW = "5be3b47a31495c2d429b0cf4";
export const ID_CATEGORY_DRAP = "5be3b47b31495c2d429b0dfa";

//
export const ID_CATEGORY_SOFA_ROSSY_LUXE_TEST = "611b916aa0da412d29b6dce5";
export const ID_CATEGORY_SOFA_ROSSY_LUXE_PROD = "611e2ae163e3ed14842f1ec7";
//
export const ID_PRODUCT_SOFA_ROSSY_LUXE_TEST = "60f3c59dfaf9a37403f5d39b";
export const ID_PRODUCT_SOFA_ROSSY_LUXE_PROD = "6119332baa8ff1396bc119c4";

export const LIST_IDS_SPECIAL_DELUXE_PILLOW_TOP = [
  "60c0d817e61c621a54e831e0",
  "60c0c5fce61c621a54e831df",
  "60e51ae3990fdb4e842963a6",
  //"60e518cf3a6a644bb510cb7b", //ID Royal in dev
];

export const LIST_IDS_CATEGORY_MATTRESS = [
  "6146cf5ef1a499586068fda9",
  "6146cd85f1a499586068fda5",
  "60e51ae3990fdb4e842963a6",
  "60c0d817e61c621a54e831e0",
  "60c0c5fce61c621a54e831df",
  "5d256668d79a2910d9f01e80",
  "5c399308988d425b952a7c9a",
  "5c3990f9988d425b952a7c96",
  "5c399053988d425b952a7c92",
  "5c398cc0988d425b952a7c8d",
  "5c08a1e86dd42a7d157ec062",
  "5c07a0f4ac711b71fb36b0cf",
  "5c079fd8ac711b71fb36b0ca",
  "5c079cffac711b71fb36b0c4",
  "5be46b7044eb2e149d7e7935",
  "5be45f7644eb2e149d7e789f",
];

export const LIST_IDS_CATEGORY_PILLOW = [
  "5be46ca544eb2e149d7e79c6",
  "5dbf97bfee7a663ec6f8cae8",
  "5dbf98d7ee7a663ec6f8caee",
  "5c08ab026dd42a7d157ec06e",
  "5c08ac616dd42a7d157ec074",
  "5d526b100fdd4f33efb8c529",
  "5fd967eb39a24b683df0a287",
  "5c39a1b8988d425b952a7ca3",
];

export const LIST_IDS_CATEGORY_BED_SHEET = [
  "60bf7fa0eb32ff6462151a67",
  "60bf7ee7eb32ff6462151a66",
  "5be5270844eb2e149d7e8d7b",
  "5c4170db88608b026c392940",
  "5c41775688608b026c392982",
  "6748992cf17b62fca119f95f",
  "674898f4f17b62fca119f858",
];

export const LIST_IDS_CATEGORY_BED_FOLDING = [
  "5c39608e988d425b952a7c2a",
  "5c3eff0488608b026c3928cf",
];

export const ID_CATEGORY_BED_FOLDING_ELEVATE_HEAD = "5c39608e988d425b952a7c2a";
export const ID_CATEGORY_BED_FOLDING_NO_ELEVATE_HEAD =
  "5c3eff0488608b026c3928cf";

export const KEY_PRODUCT_KIND = "PRODUCT_KIND";
export const KEY_SIZE = "SIZE";
export const KEY_THICK = "THICK";

export const KEY_SHIPPING_INFO = "SHIPPING_INFO";
export const KEY_SHOPPING_CART = "SHOPPING_CART";
export const KEY_VERIFY_ORDER = "verify_order_";
export const DEFAULT_OFFSET = 0;
export const DEFAULT_LIMIT = 4;

export const TYPE_POINT_RECEIVED: string = "RECEIVED";
export const TYPE_POINT_USED: string = "USED";

export const METHOD_POINT_ORDER: string = "ORDER";
export const METHOD_POINT_GAME: string = "GAME";

export const ORDER_STATUS_PENDING: string = "PENDING"; // Chờ giao hàng
export const ORDER_STATUS_SUCCESS: string = "SUCCESS"; // Giao hàng thành công
export const ORDER_STATUS_FAIL: string = "FAIL"; // Giao hàng thất bại
export const ORDER_STATUS_DELIVERING: string = "DELIVERING"; // Đang giao hàng
export const ORDER_STATUS_CANCELLED: string = "CANCELLED"; // Đơn hàng huỷ
export const ORDER_STATUS_CANCELLING: string = "CANCELLING"; // Đơn hàng đang yêu cầu hủy

export const CATEGORY_VO_BOC_GOI = 7;

// Attribute
export const PROPERTY_TYPE = {
  size: "KICH-THUOC-RONG-X-DAI",
  thick: "CAO-(Do-day)",
  foam: "TY-TRONG-(DENSITY)-MOUSSE",
  image: "HOA-VAN",
  pattern: "MA-HOA-VAN-",
  type: "LOAI",
  size_drap: "KICH-THUOC",
  cover: "VO-BOC",
};
//

// Payment method
export const PAYMENT_METHOD_COD: string = "COD";
export const PAYMENT_METHOD_TRANSFER: string = "TRANSFER";
export const PAYMENT_METHOD_CREDIT_CARD: string = "CREDIT_CARD";
export const PAYMENT_METHOD_PAYPAL: string = "PAYMENT_METHOD_PAYPAL";
export const PAYMENT_METHOD_VTPAY: string = "PAYMENT_METHOD_VTPAY";
export const PAYMENT_METHOD_PAYOO: string = "PAYMENT_METHOD_PAYOO";
export const PAYMENT_METHOD_PAYOO_E_WALLET: string =
  "PAYMENT_METHOD_PAYOO_E_WALLET";
export const PAYMENT_METHOD_PAYOO_DOMESTIC: string =
  "PAYMENT_METHOD_PAYOO_DOMESTIC";
export const PAYMENT_METHOD_PAYOO_INTERNATIONAL: string =
  "PAYMENT_METHOD_PAYOO_INTERNATIONAL";
export const PAYMENT_METHOD_PAYOO_PAY_AT_STORE: string =
  "PAYMENT_METHOD_PAYOO_PAY_AT_STORE";
export const PAYMENT_METHOD_PAYOO_TOKEN: string = "PAYMENT_METHOD_PAYOO_TOKEN";
export const PAYMENT_METHOD_PAYOO_INSTALLMENT: string =
  "PAYMENT_METHOD_PAYOO_INSTALLMENT";
export const PAYMENT_METHOD_PAYOO_QRCODE: string =
  "PAYMENT_METHOD_PAYOO_QRCODE";
export const PAYMENT_METHOD_PAYOO_APP2APP: string =
  "PAYMENT_METHOD_PAYOO_APP2APP";
export const PAYMENT_METHOD_SC: string = "PAYMENT_METHOD_SC";
export const PAYMENT_METHOD_MOMO: string = "PAYMENT_METHOD_MOMO";
export const PAYMENT_METHOD_VNPAY: string = "PAYMENT_METHOD_VNPAY";
export const PAYMENT_METHOD_PAYOO_LIST = [
  PAYMENT_METHOD_PAYOO,
  PAYMENT_METHOD_PAYOO_E_WALLET,
  PAYMENT_METHOD_PAYOO_DOMESTIC,
  PAYMENT_METHOD_PAYOO_INTERNATIONAL,
  PAYMENT_METHOD_PAYOO_PAY_AT_STORE,
  PAYMENT_METHOD_PAYOO_TOKEN,
  PAYMENT_METHOD_PAYOO_INSTALLMENT,
  PAYMENT_METHOD_PAYOO_QRCODE,
  PAYMENT_METHOD_PAYOO_APP2APP,
];
export const PAYMENT_METHOD_LABEL = {
  [PAYMENT_METHOD_COD]: "payment_method_cod",
  [PAYMENT_METHOD_CREDIT_CARD]: "payment_method_credit",
  [PAYMENT_METHOD_PAYPAL]: "payment_method_paypal",
  [PAYMENT_METHOD_VTPAY]: "payment_method_vtpay",
  [PAYMENT_METHOD_PAYOO]: "payment_method_payoo",
  [PAYMENT_METHOD_TRANSFER]: "payment_method_transfer",
  [PAYMENT_METHOD_VNPAY]: "payment_method_vnpay",
  [PAYMENT_METHOD_MOMO]: "payment_method_momo",
};
export const PAYMENT_STATUS_SUCCESS: string = "SUCCESS";
export const PAYMENT_STATUS_FAIL: string = "FAIL";
export const PAYMENT_STATUS_PENDING: string = "PENDING";
export const PAYMENT_STATUS_REFUNDED: string = "REFUNDED";
export const PAYMENT_STATUS = {
  SUCCESS: PAYMENT_STATUS_SUCCESS,
  FAIL: PAYMENT_STATUS_FAIL,
  PENDING: PAYMENT_STATUS_PENDING,
};

export const PAYMENT_METHODS_NEED_VERIFY_OTP = [
  PAYMENT_METHOD_COD,
  PAYMENT_METHOD_TRANSFER,
  PAYMENT_METHOD_PAYOO_PAY_AT_STORE,
];

export const OTP_METHOD = {
  SMS: "SMS",
  ZALO: "ZALO",
};

export const PAYMENT_STATUS_TRANSFER_UNPAID = 1;
export const PAYMENT_STATUS_TRANSFER_PAID = 2;
export const PAYMENT_STATUS_TRANSFER_PARTIAL_PAID = 3;

export const PAYMENT_STATUS_TRANSFER = {
  [PAYMENT_STATUS_TRANSFER_UNPAID]: "Chưa xác nhận",
  [PAYMENT_STATUS_TRANSFER_PARTIAL_PAID]: "Chưa xác nhận",
  [PAYMENT_STATUS_TRANSFER_PAID]: "Đã xác nhận",
};

export const RESULT_PAYMENT_PAYOO = {
  SUCCESS: "1",
  FAIL: "0",
  CANCELLED: "-1",
};

export const ORDER_STATUS_COLOR = {
  [ORDER_STATUS_PENDING]: "#a19d95",
  [ORDER_STATUS_DELIVERING]: "#86a600",
  [ORDER_STATUS_SUCCESS]: "#45ade9",
  [ORDER_STATUS_FAIL]: "#e94733",
  [ORDER_STATUS_CANCELLED]: "#e94733",
  [ORDER_STATUS_CANCELLING]: "#BF9965",
};
export const ORDER_STATUS_LABEL = {
  [ORDER_STATUS_CANCELLING]: "Đã gửi yêu cầu huỷ",
};

export const gold = "#BF9965";
export const blue_3 = "#2182C3";
export const red = "#e94733";
export const gray = "#f4f7fa";

export const COLORS = {
  WHITE: "#ffffff",
  BLACK: "#000000",
  GRAY_LIGHT: "#a19d95",
  BLUE_DARK: "#0c3b5d",
};

export const FALL_TYPES = {
  NORMAL_FALL: "NORMAL_FALL",
  FULL_FALL: "FULL_FALL",
};

export const MAX_PRODUCTS_COMPARE = 3;
export const TOTAL_REQUEST = "total-request";
export const PRODUCTS_COMPARE = "products-compare";

export const VOUCHER_INFO = "VOUCHER_INFO";

export const KEY_OPTIONS = "options";
export const ACCESS_TOKEN = "access-token";
export const SIGN_UP_VALUES = "sign-up-values";
export const USER_INFO = "user-info";
export const WISHES_LIST = "wishes-list";
export const STORE_PAYMENT_CASH = "CASH";
export const STORE_PAYMENT_CARD = "CARD";
export const STORE_PAYMENT_INSTALLMENT = "INSTALLMENT";

export const MINIMUM_PRICE_INSTALLMENT = 3000000;

export const APP_LANGUAGE = {
  English: "en",
  Vietnamese: "vn",
};

export const AREA_STORES = [
  {
    name: "store_filter_type_all",
    key: "ALL",
    order: 1,
  },
  {
    name: "store_Ha_Noi",
    key: "HN",
    order: 2,
  },
  {
    name: "store_Hai_Phong",
    key: "HP",
    order: 3,
  },
  {
    name: "store_Hue",
    key: "HUE",
    order: 4,
  },
  {
    name: "store_Da_Nang",
    key: "DN",
    order: 5,
  },
  {
    name: "store_Nha_Trang",
    key: "NHA_TRANG",
    order: 6,
  },
  {
    name: "store_Da_Lat",
    key: "DL",
    order: 7,
  },
  {
    name: "store_Bien_Hoa",
    key: "BH",
    order: 8,
  },
  {
    name: "store_TP_HCM",
    key: "TP_HCM",
    order: 9,
  },
  {
    name: "store_Vung_Tau",
    key: "VT",
    order: 10,
  },
  {
    name: "store_Can_Tho",
    key: "CT",
    order: 11,
  },
];

export const EVENT_STORES = [
  {
    name: "store_filter_type_all",
    key: "ALL",
    order: 1,
  },
];

export const STORE_PAYMENT_METHOD = [
  {
    value: STORE_PAYMENT_CASH,
    label: "store_payment_credit",
  },
  {
    value: STORE_PAYMENT_CARD,
    label: "store_payment_cash",
  },
  {
    value: STORE_PAYMENT_INSTALLMENT,
    label: "store_payment_paying",
  },
];

export const STORE_FILTER_TYPE = [
  {
    value: -1,
    label: "store_filter_type_all",
  },
  {
    value: false,
    label: "store_filter_type_store",
  },
  {
    value: true,
    label: "store_filter_type_agency",
  },
];

export const LANGUAGES = {
  en: "English",
  vn: "Tiếng Việt",
};

export const LANGUAES_MOBILE = {
  en: "EN",
  vn: "VN",
};

export const BREACK_POINT_HEADER = 845;
export const BREACK_POINT_WRAP_PRODUCT_DETAIL = 1224;
export const WIDTH_IPAD = 768;
export const MAX_WIDTH_IPAD_PRO = 1366;
export const WIDTH_MOBILE = 576;
export const WIDTH_HEADER = 840;

export const POLICY = {
  HELP_PAYMENT: "help_payment",
  HELP_SHIPING: "help_shiping",
  HELP_GUARANTEE: "help_guarantee",
  HELP_SECURITY_PAYMENT: "help_security_payment",
  HELP_SECURITY: "help_security",
  TRADING_TERMS: "trading_terms",
  INTRO_COMPANY: "intro_company",
  HELP_USE: "help_use",
};

export const HELP_MENU = [
  {
    key: "help_use",
    name: "help_order_label",
  },
  // {
  //   key: "help_guarantee",
  //   name: "return_policy_label",
  // },
  // {
  //   key: "slug_questions",
  //   name: "questions_label",
  // },
  // {
  //   key: "slug_user_manual_clean_videos",
  //   name: "user_manual_clean_videos_label",
  // },
];

export const WEBSITE_KYMDAN_STORE = "WebsiteKymdanStore";

export const EMAIL_CONTACT = "contactus@kymdan.com";
export const PHONE_CONTACT = "1800 9053";
export const BO_CONG_THUONG =
  "http://online.gov.vn/CustomAppDisplay.aspx?DocId=703";
export const STORE_AGENCY_LINK =
  "https://www.kymdan.com/bai-viet/he-thong-phan-phoi";
export const INSTALLMENT_KYMDAN =
  "https://www.kymdan.com/bai-viet/tra-gop-0-lai-suat";

export const MESSENGER_URL = "https://m.me/kymdanofficial";
